/* ==========================================================================
   Quantity Input & Quantity Popover
   Used in cart drawer and anywhere the quantity-input snippet is rendered.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Quantity Input ---------- */
  if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.f-quantity__input');
        this.minusBtn = this.querySelector('[name="minus"]');
        this.plusBtn = this.querySelector('[name="plus"]');

        if (this.minusBtn) {
          this.minusBtn.addEventListener('click', () => this.step(-1));
        }
        if (this.plusBtn) {
          this.plusBtn.addEventListener('click', () => this.step(1));
        }
      }

      step(direction) {
        if (!this.input) return;
        var step = parseInt(this.input.step) || 1;
        var min = parseInt(this.input.min) || 0;
        var max = this.input.max ? parseInt(this.input.max) : Infinity;
        var value = parseInt(this.input.value) || min;

        value += step * direction;
        value = Math.max(min, Math.min(max, value));

        this.input.value = value;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    customElements.define('quantity-input', QuantityInput);
  }

  /* ---------- Quantity Popover ---------- */
  if (!customElements.get('quantity-popover')) {
    class QuantityPopover extends HTMLElement {
      connectedCallback() {
        this.infoBtn = this.querySelector('.quantity-popover__info-button');
        this.infoPanel = this.querySelector('.quantity-popover__info');
        this.closeBtn = this.infoPanel?.querySelector('.button-close');

        if (this.infoBtn && this.infoPanel) {
          this.infoBtn.addEventListener('click', () => this.toggle());
        }
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close());
        }
      }

      toggle() {
        var expanded = this.infoBtn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.infoBtn.setAttribute('aria-expanded', 'true');
        this.infoPanel.removeAttribute('hidden');
      }

      close() {
        this.infoBtn.setAttribute('aria-expanded', 'false');
        this.infoPanel.setAttribute('hidden', '');
      }
    }
    customElements.define('quantity-popover', QuantityPopover);
  }
})();
